import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function Confidentialite() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/site-settings").then((r) => setS(r.data || {})).catch(()=>{}); }, []);
  const email = s.contact_email || "info.proxireduc@gmail.com";

  return (
    <div className="max-w-3xl mx-auto px-4 py-14" data-testid="page-confidentialite">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center"><ShieldCheck size={22}/></div>
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold">Politique de confidentialité</h1>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 space-y-6 text-sm text-slate-700 leading-relaxed">
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Responsable du traitement</h2>
          <p className="mt-2">
            {s.legal_company || "PROXIreduc-28"} — contact : <a className="text-[#E05638] underline" href={`mailto:${email}`}>{email}</a>.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Données collectées</h2>
          <ul className="mt-2 list-disc pl-5 space-y-1">
            <li><b>Compte utilisateur</b> : nom, prénom, email, ville, code postal, code d'affiliation.</li>
            <li><b>Compte professionnel</b> : coordonnées de contact, raison sociale, adresse, catégorie.</li>
            <li><b>Demandes de contact</b> : nom, email, téléphone, ville, message.</li>
            <li><b>Techniques</b> : cookie d'authentification (session), logs serveur (adresse IP, agent).</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Finalités & bases légales</h2>
          <ul className="mt-2 list-disc pl-5 space-y-1">
            <li>Fournir l'accès à la plateforme et gérer votre compte (exécution du contrat).</li>
            <li>Répondre à vos demandes de contact (intérêt légitime).</li>
            <li>Envoyer les alertes offres uniquement si vous les avez explicitement acceptées (consentement).</li>
            <li>Statistiques d'usage internes anonymisées (intérêt légitime).</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Durée de conservation</h2>
          <p className="mt-2">
            Comptes actifs : tant que le compte est utilisé, puis 3 ans d'inactivité maximum.<br/>
            Demandes de contact : 3 ans à des fins de gestion commerciale.<br/>
            Logs techniques : 12 mois.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Destinataires</h2>
          <p className="mt-2">
            Vos données sont accessibles uniquement à l'équipe interne PROXIreduc-28 et à nos
            sous-traitants techniques (hébergement, envoi d'emails transactionnels via Resend).
            Aucune donnée n'est vendue ou transmise à des tiers publicitaires.
          </p>
        </section>
        <section className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
          <h2 className="font-heading text-lg font-bold text-slate-900">Vos droits (RGPD)</h2>
          <p className="mt-2">
            Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et
            d'opposition. Depuis votre <a className="text-[#E05638] underline" href="/compte">espace personnel</a>,
            vous pouvez à tout moment :
          </p>
          <ul className="mt-2 list-disc pl-5 space-y-1">
            <li><b>Exporter vos données</b> au format JSON.</li>
            <li><b>Supprimer votre compte</b> (droit à l'oubli). Vos données personnelles sont alors anonymisées.</li>
          </ul>
          <p className="mt-2">
            Pour toute autre question relative à vos données, écrivez-nous à{" "}
            <a className="text-[#E05638] underline" href={`mailto:${email}`}>{email}</a>. En cas de désaccord,
            vous pouvez saisir la CNIL (<a className="text-[#E05638] underline" href="https://www.cnil.fr" target="_blank" rel="noreferrer">cnil.fr</a>).
          </p>
        </section>
      </div>
    </div>
  );
}
